const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_retreat-builder-1/artifacts/o4evfjm1_IMG_9838%20%281%29.jpeg";

const ValouseHero = () => {
  return (
    <>
      {/* Hero Image - Full width, no text overlay */}
      <section id="hero-image" className="w-full">
        <div className="relative w-full h-[60vh] sm:h-[70vh] overflow-hidden">
          <img
            src={HERO_IMAGE}
            alt="Retraite initiatique COCON Valouse - Hameau privatisé en Drôme Provençale"
            className="w-full h-full object-cover"
          />
        </div>
      </section>
      
      {/* Hero Text Block - Below the image */}
      <section id="hero" className="py-16 sm:py-24 px-6 bg-[#ecd9c1]">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          
          {/* Premium micro-heading structure */}
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#5C4A3D]">
            Drôme Provençale
          </p>
          
          <h1 
            className="font-serif text-4xl sm:text-5xl md:text-6xl tracking-wide text-[#C5A059]"
          >
            COCON
          </h1>
          
          <p 
            className="font-serif text-lg sm:text-xl text-[#3F2A24]/70 italic"
          >
            Revenir de la tête au cœur
          </p>
          
          <div className="w-16 h-[1px] bg-[#C5A059]/70 mx-auto" />
          
          <div className="space-y-2">
            <p 
              className="font-serif text-xl sm:text-2xl md:text-3xl text-[#3F2A24]"
            >
              Ne plus te retenir.
            </p>
          </div>
          
          <p 
            className="text-sm sm:text-base text-[#5C4A3D]"
          >
            Un cycle initiatique contemporain.
          </p>
          
          <div className="pt-6">
            <a
              href="#formules"
              onClick={(e) => { e.preventDefault(); document.querySelector('#formules')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="inline-block px-8 py-4 bg-[#C5A059] text-[#3F2A24] rounded-full uppercase tracking-widest text-sm hover:bg-[#bdb7a7] hover:text-[#3F2A24] transition-colors duration-300 min-h-[48px]"
              data-testid="hero-cta-btn"
            >
              Je m'ouvre au cycle
            </a>
          </div>
          
          <p 
            className="text-xs md:text-sm tracking-[0.15em] text-[#5C4A3D]"
          >
            20 places · Hameau privatisé · Cycle complet avant, pendant et après
          </p>
        </div>
      </section>
    </>
  );
};

export default ValouseHero;
